<template>
  <div style="height: 275px;">
    <l-map style="height: 275px;"
           :zoom="zoom"
           :center="center"
           @update:center="centerUpdate"
           @update:zoom="zoomUpdate"
           :ref="code"
           @dblclick="changeMarker"
    >
      <l-tile-layer :url="url"></l-tile-layer>
      <l-marker
              :lat-lng="position"
              @update:lat-lng="positionUpdate"
              :draggable=true
      >
      </l-marker>
    </l-map>
  </div>
</template>

<script>
  import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
  import { Icon } from 'leaflet';

  delete Icon.Default.prototype._getIconUrl;
  Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });

  export default {
    name: 'MyMap',
    components: {
      LMap,
      LTileLayer,
      LMarker,
    },
    props: {
      position: {
        default: { lat: "51.483427", lng: "-0.1295185" }
      },
      center: {
        default: { lat: "51.483427", lng: "-0.1295185" }
      },
      zoom: {
        default: 6
      },
      code: {
        default: null
      }
    },
    data () {
      return {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      };
    },
    methods: {
      zoomUpdate(zoom) {
        this.$emit('zoom-change', zoom, this.code);
      },
      centerUpdate(center) {
        this.$emit('center-change', center, this.code);
      },
      positionUpdate(lat_long) {
        this.$emit('position-change', lat_long, this.code);
      },
      changeMarker(event) {
        this.position = event.latlng
      }
    },
    mounted() {
      let mapObj = this.$refs[this.code].mapObject;
      this.$emit('map-init', mapObj);
    }
    

  };
</script>

<style scoped>

</style>